// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__1Sb0Z","root--md":"Container_root--md__1LPM2"};